<div class="mob-cartaos mob-box-container mob-bg-blue">
  <div class="container">
    <div class="row mob-cartaos">
      <div class="col">
        <!-- <div class="mob-image text-center mb-40"> <img class="d-none-lg" alt="cartoes"
                        src="{{VO?.offer_card_image?.MediaImagemProposta_bloblink_}}">
                    <img class="d-none-sm" alt="cartoes"
                        src="{{VO?.offer_card_image?.PadraoImagemProposta_bloblink_}}">
                </div> -->
        <div class="mob-info">
          <div class="mob-title-3 mb-16">{{ VO?.offer_card?.subtitle }}</div>
          <div
            class="mob-title-5 mb-24"
            [innerHtml]="VO?.offer_card?.description"
          ></div>
          <div class="mob-link">
            <span class="mob-title-2 mob-boston"
              >{{ VO?.offer_card?.title }}</span
            >
          </div>

          <div class="mob-form">
            <form [formGroup]="form" *ngIf="form" class="form">
              <div class="row">
                <div class="col-md-7 col-sm-12">
                  <div class="margin-bottom-cel">
                    <dss-form-field
                      [isError]="formSubmitted && cpf.invalid"
                      autocomplete="off"
                    >
                      <input
                        id="inputMiddle"
                        #cpfElementMiddle
                        type="text"
                        formControlName="cpf"
                        trackingFill
                        [eventLabel]="'input:cpf'"
                        dssMask="CPF"
                        autocomplete="off"
                        inputmode="numeric"
                      />
                      <label dssLabel>{{ VO?.documentCPF?.label }}</label>
                      <span *ngIf="cpf?.errors?.required" dssError>
                        {{ VO?.documentCPF?.validator_required }}</span
                      >
                      <span *ngIf="cpf?.errors?.invalidCPF" dssError
                        >{{ VO?.documentCPF?.validator_invalidFormat }}</span
                      >
                    </dss-form-field>
                  </div>
                </div>
                <div class="col-md-5 col-sm-12">
                  <div class="ta-righ">
                    <mob-button
                      *ngIf="VO?.continueButton?.label"
                      (actionClick)="send($event)"
                      [type]="'landing-page'"
                      (click)="cpfElementMiddle.focus()"
                      [styleClass]="
                        'mob-btn mob-btn-primary mob-btn-3 min-w-200 mob-btn-conta'
                      "
                      [text]="VO?.continueButton?.label"
                      [eventLabel]="'botao:quero-abrir-conta-2'"
                      [action]="'next-middle'"
                    >
                    </mob-button>
                  </div>
                  <!-- <p class="mob-disclaimer view-mobile">
                    *Sujeito à análise de crédito. *Produtos podem ser
                    contratados de forma independente.
                  </p> -->
                </div>
              </div>
            </form>
          </div>
          <p
            class="refuse-card-disclaimer"
            [innerHTML]="VO.requestCardDiscraimer.description"
          ></p>
        </div>
      </div>
      <div class="col">
        <div class="mob-cardIntro">
          <div class="mob-cardIntro-head">
            <div
              class="mob-cardIntro-img"
              [ngStyle]="{'background-image':  'url(' + normalizeImage(VO.boxes_imagem_3, isMock, 'cartoes_sx')+ ')'}"
            ></div>
          </div>
          <div class="mob-cardIntro-body">
            <div class="title">{{VO?.productCard_title}}</div>
            <div class="mob-hr"></div>
            <div *ngFor="let item of VO?.productCard.benefits; let i = index;">
              <div class="item" [innerHtml]="item?.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
